/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ViewPreferenceCategory {
	Folder = 1,
	View = 2,
	Report = 3,
}
